import {
  Avatar,
  Checkbox,
} from "@mui/material";
import React from "react";
import {
  Container,
  Content,
  ContentBody,
  ContentTitle,
  Title,
} from "./styles";
import { useParams } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { UserPermissions } from "../../../App";

interface Props {
  userPermissions: UserPermissions;
}
const ViewPatients: React.FC<Props> = ({ userPermissions }) => {
  let { username } = useParams();

  // User profile picture
  const [logo, setLogo] = React.useState<string>("");

  const setSoftwareAccess = (params: {
    patientUsername: string;
    software: {
      id: string;
      type: string;
      version: string;
    };
    allowUsage: boolean;
  }) => {
    const { patientUsername, software, allowUsage } = params;

    fetch("/api/v1/patient/authorized_software/change", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        patient: patientUsername,
        id: software.id,
        type: software.type,
        version: software.version,
        allowUsage: allowUsage,
      }),
    }).then(() => {
      getClinicianSoftwareList(username || "");
    });
  };

  const getClinicianSoftwareList = (patientUsername: string) => {
    fetch("/api/v1/patient/authorized_software/list", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        patient: patientUsername,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Clinician soft:", data);

        setTableData(data.list);
        // getClinicianSoftwareList(username || ""); // ?
      });
  };

  const getUser = () => {
    fetch("/api/v1/patient/get", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLogo(data.logo);
      });
  };

  const columns = [
    {
      field: "id",
      headerName: "Package ID",
      width: 240,
    },
    {
      field: "name",
      headerName: "Name",
      width: 240,
    },
    {
      field: "type",
      headerName: "Type",
      width: 100,
    },
    {
      field: "version",
      headerName: "Version",
      width: 100,
    },
    {
      field: "allow",
      headerName: "Allow usage",
      width: 95,
      renderCell: (params: any) => (
        <span style={{}}>
          <Checkbox
            checked={params.row.allow}
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            color="success"
            onChange={(event: any) => {
              setSoftwareAccess({
                patientUsername: username || "",
                software: {
                  id: params.row.id,
                  type: params.row.type,
                  version: params.row.version,
                },
                allowUsage: event.target.checked,
              });
            }}
          />
        </span>
      ),
    },
  ];

  const [tableData, setTableData] = React.useState([]);

  React.useEffect(() => {
    getUser();
    getClinicianSoftwareList(username || "");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Title>Patient software access list</Title>

      <Content>
        <ContentTitle>
          <Avatar
            src={logo}
            sx={{ height: "2rem", width: "2rem", marginRight: "1rem" }}
          />
          {username}
        </ContentTitle>

        <ContentBody>
          <div style={{ height: 500, width: "100%", paddingTop: "1rem" }}>
            <DataGrid
              getRowId={(row: any) => `${row.id}:${row.type}:${row.version}`}
              style={{ fontWeight: 900, color: "rgba(55, 73, 87, 0.7)" }}
              rows={tableData}
              columns={columns}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              components={{ Toolbar: GridToolbar }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </div>
        </ContentBody>
      </Content>
      {/*<div style={{ height: 500, width: '100%', paddingTop: "1rem" }}>

    </div>*/}
    </Container>
  );
};

export default ViewPatients;
